import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const odemeSaglayicisi = z.enum(['IYZICO', 'PARAM', 'AKBANK', 'CUZDAN', 'MANUEL']);
export const odemeDurumu = z.enum(['BEKLEMEDE', 'BASARILI', 'BASARISIZ', 'IADE_EDILDI']);
export const odeme = z.object({
    id: z.string(),
    kiralamaId: z.string(),
    kiralamaKod: z.string().nullable().optional(),
    musteriTelefon: z.string().nullable().optional(),
    musteriAdSoyad: z.string().nullable().optional(),
    saglayici: odemeSaglayicisi,
    saglayiciRef: z.string().nullable().optional(),
    miktar: z.string(),
    paraBirimi: paraBirimi,
    durum: odemeDurumu,
    hataMesaji: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const odemeSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    arama: z.string().optional(),
    durum: odemeDurumu.optional(),
    saglayici: odemeSaglayicisi.optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
// --- IADE ---
export const iadeSebebi = z.enum([
    'TEKNIK_ARIZA',
    'MUSTERI_TALEBI',
    'ERKEN_IPTAL',
    'ADMIN_DUZELTME',
    'DIGER',
]);
export const iadeDurumu = z.enum(['BEKLEMEDE', 'TAMAMLANDI', 'REDDEDILDI']);
export const iade = z.object({
    id: z.string(),
    odemeId: z.string(),
    kiralamaId: z.string(),
    kiralamaKod: z.string().nullable().optional(),
    miktar: z.string(),
    paraBirimi: paraBirimi,
    sebep: iadeSebebi,
    aciklama: z.string().nullable().optional(),
    durum: iadeDurumu,
    yapanKullaniciId: z.string(),
    yapanAdSoyad: z.string().nullable().optional(),
    olusturmaTarihi: z.string().datetime(),
});
export const iadeSorgusu = z.object({
    sayfa: z.coerce.number().int().min(1).default(1),
    boyut: z.coerce.number().int().min(1).max(100).default(20),
    durum: iadeDurumu.optional(),
    sebep: iadeSebebi.optional(),
    baslangicTen: z.string().datetime().optional(),
    baslangicAKadar: z.string().datetime().optional(),
});
//# sourceMappingURL=odeme.js.map